// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid>
    <v-alert
      type="warning"
      dismissible=true
      :value="$route.query.error !== undefined">
      SSO error: {{ $route.query.error }}
    </v-alert>
    <v-row>
      <v-col cols="12" md="4" offset-md="4" sm="6" offset-sm="3">
        <img
            v-bind:src="'static/logo.png'"
            style="width:75%; display:block; margin-right:auto; margin-left:auto;"
            class="my-5">
        <v-card>
          <v-card-title>
            <span class="headline">Login</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
            label="Email"
            id="email"
            required
            v-model="credentials.username"
            v-on:keyup.enter="login()"
            ></v-text-field>
            <v-text-field
            label="Password"
            id="password"
            :type="pwdVisibility ? 'text' : 'password'"
            required
            v-model="credentials.password"
            :append-icon="pwdVisibility ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="pwdVisibility = !pwdVisibility"
            v-on:keyup.enter="login()"
            ></v-text-field>
            <router-link :to="{name: 'passwordResetRequest'}">Forgot My Password</router-link>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text darken-1" text @click.native="login">Login</v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat class="text-with-lines my-1" v-if="oktaAvailable">
          <v-card-text class="text-content">
            OR
          </v-card-text>
        </v-card>
        <v-btn outlined
          style="display: block; margin-right:auto; margin-left:auto;"
          v-if="oktaAvailable"
          @click.native="oktaLogin"
          > <img src="static/okta.png" style="width:15%; margin-right: 5%;">
          Login with Okta
        </v-btn>
      </v-col>
    </v-row>

  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<style scoped>
.text-with-lines {
  position: relative;
}

.text-content {
  position: relative;
  text-align: center;
  padding: 10px 20px;
}

.text-with-lines::before,
.text-with-lines::after {
  content: '';
  position: absolute;
  top: 50%;
  height: 1px;
  background-color: rgba(128, 128, 128, 0.5);
}

.text-with-lines::before {
  left: 0;
  width: calc(50% - 20px);
}

.text-with-lines::after {
  right: 0;
  width: calc(50% - 20px);
}
</style>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'
import ApiRequests from '@/api/ApiRequests'

import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      oktaAvailable: false,
      errorText: '',
      pwdVisibility: false
    }
  },

  methods: {
    ...mapActions([
      'getUserData'
    ]),

    isOktaAvailable: function () {
      ApiRequests.oktaAvailable().then(_ => {
        this.oktaAvailable = true
      }).catch(_ => {
        this.oktaAvailable = false
      })
    },

    oktaLogin: function () {
      window.location.href = '/auth/okta/redirect'
    },

    login: function () {
      var credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      }
      axios.post('/auth/login', credentials, {}).then(response => {
        var ref = this.$route.query.referer
        if (ref === undefined) {
          this.$router.push({name: 'images'})
          return
        }
        var split = ref.split('?')
        var path = ''
        if (split.length > 0) {
          path = split[0]
        }
        if (ref && path !== '' && !ref.includes('login')) {
          this.$router.push(ref)
        } else {
          this.$router.push({name: 'images'})
        }
        this.getUserData()
      }).catch(e => {
        if (e.response.data !== undefined && e.response.data.reason !== undefined) {
          if (e.response.data.reason === 'rate limited') {
            this.errorText = 'Too many recent failed logins: wait a minute and try again'
          } else if (e.response.data.reason === 'account locked') {
            this.errorText = 'Too many recent failed logins: use Forgot My Password to unlock your account'
          } else {
            this.errorText = 'Invalid username or password'
          }
        } else {
          this.errorText = 'Invalid username or password'
        }
      })
    }
  },

  mounted () {
    this.isOktaAvailable()
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?2008b6e5